import { supabaseClient } from "@/lib/database/supabase";
import { RouteName } from "@/lib/router/routes";
import { RunReviewWithVotes } from "@shared/lib/database/query.types";
import { defineStore } from "pinia";
import { ref } from "vue";
import useModalStore from "./useModalStore";

export default defineStore("RunReviewStore", () => {
  const {
    openModal,
  } = useModalStore();

  const runReviewMap = ref<Map<string, RunReviewWithVotes>>(new Map());
  function getReviewForRun (runId: string) {
    return runReviewMap.value.get(runId) ?? null;
  }

  function setReviewForRun (runId: string, runReview: RunReviewWithVotes) {
    runReviewMap.value.set(runId, runReview);
  }

  function viewReviewForRun (runId: string, runReview?: RunReviewWithVotes) {
    if (runReview) setReviewForRun(runId, runReview);

    return openModal({
      name: RouteName.runReview,
      params: {
        runId,
      },
    });
  }

  async function fetchReviewForRun (runId: string) {
    const {
      data: runReview,
    } = await supabaseClient.from("run_reviews")
      .select("*, award_votes(*)")
      .eq("run_id", runId)
      .limit(1)
      .maybeSingle()
      .throwOnError();

    if (runReview) {
      setReviewForRun(runId, runReview);
      return runReview;
    }
  }

  return {
    getReviewForRun,
    setReviewForRun,
    viewReviewForRun,
    fetchReviewForRun,
  };
});
